import React from 'react'
import { Outlet } from 'react-router-dom'

import styles from './Settings.module.css'

import PageLoader from 'Layout/PageLoader'
import { PageTabPanel } from 'Layout/PageTabs'

import { useGetBotProfileQuery } from 'Services/bot-profiles'

import { BotSettingsContext } from './SettingsContext'

const SettingsTabPanel = (props) => {
  const { botId, hideBg = false } = props

  const { isLoading, data: bot } = useGetBotProfileQuery(botId)

  if (isLoading) {
    return <PageLoader />
  }

  return (
    <PageTabPanel hideBg={hideBg} className={styles.Panel}>
      <BotSettingsContext.Provider value={bot}>
        <Outlet />
      </BotSettingsContext.Provider>
    </PageTabPanel>
  )
}

export default SettingsTabPanel
